<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <!-- Logo -->
          <div class="text-center mb-4">
            <img src="/img/logo.png" alt="Logo" class="auth-logo">
          </div>

          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body class="text-center">

                <h1 class="mb-2">{{ $t('magicLogin.title') }}</h1>
                <p class="text-muted mb-4">{{ $t('magicLogin.description') }}</p>

                <!-- Native form POST: browser handles cookie + redirect natively.
                     Email scanners follow GET links but do not click buttons,
                     so the token is safe until the user explicitly submits. -->
                <form :action="postUrl" method="post">
                  <b-button
                    type="submit"
                    variant="primary"
                    class="px-4 bg-protokol-royal-purple protokol-royal-purple w-100"
                  >
                    {{ $t('magicLogin.continue') }}
                  </b-button>
                </form>

              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagicLogin',
  computed: {
    postUrl: function () {
      return this.$env.get('API_HOST') + '/v1/user/magic-login/' + this.$route.params.token
    }
  }
}
</script>

<style scoped>
.auth-logo {
  max-width: 60px;
  height: auto;
  margin-bottom: 1rem;
}
</style>
